import { render, staticRenderFns } from "./UN160A5S.vue?vue&type=template&id=cab397b8&"
import script from "./UN160A5S.vue?vue&type=script&lang=js&"
export * from "./UN160A5S.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports